import '@lightspeed/account-services-invoices/dist/index.min.css';

import React from 'react';

import { Invoices } from '@lightspeed/account-services-invoices';

import { getLanguage, getTimezone } from 'helpers/locale';

import { useLocale } from '../shared/useLocale';

const InvoiceTable = () => {
  const locale = useLocale();

  const defaultArgs = {
    baseUrl: `${window.location.origin}/admin/subscription/invoice/v0`,
    productCode: 'lsr',
    entityType: 'subscription' as 'subscription' | 'location',
    customHeaders: {},
    entityId: (window.merchantos.session.getSystemCustomerID() || 0).toString(),
    showPaymentLink: false,
    locale: getLanguage(locale),
    timezone: getTimezone(),
  };

  return <Invoices {...defaultArgs} />;
};

export default InvoiceTable;
